__turbopack_context__.v({
  "className": "opendyslexic_fdedf355-module__X7MRKW__className",
  "variable": "opendyslexic_fdedf355-module__X7MRKW__variable",
});
